import { ModalService } from '@capsicum/common-web';

import { NCWalletRecoverySuccessDrawer } from '../../ui';

export const useNCWalletRecoverySuccessDrawer = () => {
	const openWalletRecoverSuccessDrawer = () =>
		ModalService.addModal({
			isClosable: false,
			renderComponent: ({ close }) => <NCWalletRecoverySuccessDrawer closeModal={close} />
		});

	return {
		openWalletRecoverSuccessDrawer
	};
};
